export const storylyInitialValues = {
  isProductFallbackEnabled: true,
  isProductCartEnabled: true,
  layout: 'modern',
  barLayout: 'classic',
  videoFeedView: 'bar',
  props: {
    storyGroupSizeWidth: '72',
    storyGroupSizeHeight: '72',
    storyGroupTextColor: '#4A4A4A',
    storyGroupTextVisibility: true,
    storyGroupSize: '72x72',
    storyGroupBorderRadius: 72,
    storyGroupTextFont: 'Storyly-Inter',
    storyTextFont: 'Storyly-Inter',
    storyGroupAlign: 'center',
    storyGroupMarginHorizontal: 10,
    storyGroupIconBorderColorNotSeen: ['#FFCC64', '#DC475B', '#992DBD'],
    storyGroupIconBorderColorSeen: ['#DBDBDB'],
    storyGroupTextSize: 13,
    storyGroupTextWeight: '500',
    storyGroupBorderSize: 2,
    storyGroupTextLineHeight: 1.25,
    storyGroupPinBackgroundColor: '#FFCB00',
    storyGroupPinIcon: null,
    storyGroupTextMarginTop: 6,
    storyGroupTextSeenColor: '#333',
    storyBorderGapSize: 3,
    storyGroupPinSize: 20,
    storyGroupProgressBackgroundColor: 'rgba(255, 255, 255, 0.5)',
    storyGroupProgressFillColor: 'rgba(255, 255, 255, 1)',
    storyGroupTitleVisible: true,
    storyGroupCoverVisible: true,
    storyGroupCloseButtonVisible: true,
    storyGroupHeadlineShadowVisible: true,
    storyGroupTextLineCount: 2,
    storyGroupPinRadius: 100,
    storyGroupBackgroundColor: '#fff',
    storyGroupBadgeTextSize: 12,
    storyGroupBadgePosition: 'bottom_center',
    scrollIndicator: 'on',
  },
};
